<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="heading_id_2"><a id="page_vii"></a><strong>Contents</strong></h2>
<p class="tocchap"><a class="nounder" href="#/Text/ch01#ch01">Thirteen</a></p>
<p class="tocchap"><a class="nounder" href="#/Text/ch02#ch02">The Usual Gang of Idiots</a></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch03#ch03" title="Link target outside of Sample">A Discipline Problem</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch04#ch04" title="Link target outside of Sample">What Happened to God</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch05#ch05" title="Link target outside of Sample">Where the Wild Things Are</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch06#ch06" title="Link target outside of Sample">A Priest with a Girlfriend</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch07#ch07" title="Link target outside of Sample">Did You Think I Was Tame?</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch08#ch08" title="Link target outside of Sample">Southern Gothic</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch09#ch09" title="Link target outside of Sample">Precipitation and Anchovies</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch10#ch10" title="Link target outside of Sample">Shopping on a Budget</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch11#ch11" title="Link target outside of Sample">Rebels of the Blessed Heart</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch12#ch12" title="Link target outside of Sample">Pets</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch13#ch13" title="Link target outside of Sample">Food Chain</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch14#ch14" title="Link target outside of Sample">A Test of the Emergency Broadcast System</span></p>
<p class="tocchap"><a id="page_viii"></a><span class="nounder" href="#/Text/ch15#ch15" title="Link target outside of Sample">Welcome to Horrible Movies</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch16#ch16" title="Link target outside of Sample">Another Color</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch17#ch17" title="Link target outside of Sample">Bwana Tim</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch18#ch18" title="Link target outside of Sample">Banshee in the Woods</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch19#ch19" title="Link target outside of Sample">Underground</span></p>
<p class="tocchap"><span class="nounder" href="#/Text/ch20#ch20" title="Link target outside of Sample">Not Approved by the Comics Code Authority</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?2054a1d7